import { ChangeDetectionStrategy } from '@angular/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { initialize } from '@ionic/core';
import { DetaillineDTOModel } from 'src/app/models/detaillineDTO.model';
import { LokijsService } from 'src/app/services/database/lokijs.service';

@Component({
  selector: 'delivery-back-choice',
  //changeDetection : ChangeDetectionStrategy.OnPush,
  templateUrl: './delivery-back-choice.component.html',
  styleUrls: ['./delivery-back-choice.component.scss'],
})

export class DeliveryBackChoiceComponent implements OnInit {
  @Input() transportChoices: string[];
  @Output() transportChoicesChange: EventEmitter<string[]> = new EventEmitter<string[]>();
  
  transportFrom= '';
  transportTo='';

  transports: string[2];
  
  constructor() {

  }

  ngOnInit() {
    this.transportFrom = this.transportChoices[0];
    this.transportTo = this.transportChoices[1];
    if( !this.transportFrom || this.transportFrom.length === 0){
      this.transportFrom = 'Van Collect';
    }
    if( !this.transportTo || this.transportTo.length === 0){
      this.transportTo = 'Van Deliver';
    }
    

  }

  handleTransportFromChange($event){

    console.log($event.target.value);
    this.transportFrom = $event.target.value;
    this.transportChoices[0] = $event.target.value;
   
  }
  
  handleTransportToChange($event){

    console.log($event.target.value);
    this.transportTo = $event.target.value;
    this.transportChoices[1] = $event.target.value;
   
  }

}
